import { Children, cloneElement, isValidElement } from 'react';
import { isFragment } from 'react-is';

var fragmentMap = function fragmentMap(children, callback) {
  return Children.map(children, function (child, index) {
    if (isFragment(child)) {
      return /*#__PURE__*/cloneElement(child, {
        children: fragmentMap(child.props.children, callback)
      });
    }
    if (! /*#__PURE__*/isValidElement(child)) {
      return child;
    }
    return callback(child, index);
  });
};
var fragmentCount = function fragmentCount(children) {
  return Children.toArray(children).reduce(function (count, child) {
    if (isFragment(child)) {
      return count + fragmentCount(child.props.children);
    }
    if (! /*#__PURE__*/isValidElement(child)) {
      return count;
    }
    return count + 1;
  }, 0);
};

export { fragmentCount, fragmentMap };
